var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "role-edit" } }, [
    _c("div", { staticClass: "card shadow-sm" }, [
      _c("div", { staticClass: "card-header" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("SupsisButton", {
                  staticClass: "mr-3",
                  attrs: { icon: "arrow_back" },
                  on: { click: _vm.handleCancel },
                }),
                _vm._v(" "),
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(
                    _vm._s(
                      _vm.roleId === "new"
                        ? _vm.$t("message.newRoleCreate")
                        : _vm.$t("message.editRole")
                    )
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-actions d-flex" },
              [
                _c(
                  "SupsisButton",
                  {
                    staticClass: "mr-2",
                    attrs: { ghost: "" },
                    on: { click: _vm.handleCancel },
                  },
                  [
                    _c("span", { staticClass: "material-icons mr-1" }, [
                      _vm._v("close"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.cancelText")) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", disabled: _vm.loading },
                    on: { click: _vm.handleSave },
                  },
                  [
                    !_vm.loading
                      ? [
                          _c("span", { staticClass: "material-icons mr-1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.roleId === "new" ? "add_circle" : "save"
                              )
                            ),
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.roleId === "new"
                                  ? _vm.$t("message.create")
                                  : _vm.$t("message.save")
                              ) +
                              "\n                        "
                          ),
                        ]
                      : [
                          _c(
                            "span",
                            { staticClass: "material-icons spinner mr-1" },
                            [_vm._v("autorenew")]
                          ),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.roleId === "new"
                                  ? _vm.$t("message.creatingRole")
                                  : _vm.$t("message.savingRole")
                              ) +
                              "\n                        "
                          ),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _vm.$validator.errors.items.length
          ? _c(
              "div",
              { staticClass: "alert alert-danger" },
              _vm._l(_vm.$validator.errors.items, function (err) {
                return _c("div", { key: err.id }, [
                  _c("span", [_vm._v(_vm._s(err.msg))]),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 mb-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.roleName")))]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.role.name,
                    expression: "role.name",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  name: _vm.$t("message.roleName"),
                  placeholder: _vm.$t("message.roleName"),
                },
                domProps: { value: _vm.role.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.role, "name", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12 mb-4" }, [
            _c(
              "div",
              { staticClass: "permission-section" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "section-header mb-3 d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.$t("message.rolePermissions"))),
                    ]),
                    _vm._v(" "),
                    _c("ModuleToggle", {
                      attrs: {
                        "is-active": _vm.isAllPermissionsSelected,
                        "is-partial": _vm.isPartiallySelected,
                        title: _vm.$t("message.toggleAllPermissions"),
                      },
                      on: { toggle: _vm.toggleAllPermissions },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.groupedPermissions, function (moduleGroup) {
                  return _c(
                    "div",
                    {
                      key: "module-" + moduleGroup.key,
                      staticClass: "permission-card mb-3",
                    },
                    [
                      _c("module-header", {
                        attrs: {
                          "module-name": moduleGroup.module,
                          "module-icon": _vm.getModuleIcon(moduleGroup.key),
                          "is-module-fully-selected":
                            _vm.isModuleFullySelected(moduleGroup),
                          "is-module-partially-selected":
                            _vm.isModulePartiallySelected(moduleGroup),
                          "is-expanded": _vm.expandedModules[moduleGroup.key],
                        },
                        on: {
                          "toggle-accordion": function ($event) {
                            return _vm.toggleModuleAccordion(moduleGroup.key)
                          },
                          "toggle-all": function ($event) {
                            return _vm.toggleAllModulePermissions(moduleGroup)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.expandedModules[moduleGroup.key],
                              expression: "expandedModules[moduleGroup.key]",
                            },
                          ],
                          attrs: { role: "tabpanel" },
                        },
                        [
                          _c("div", { staticClass: "p-0" }, [
                            _c(
                              "div",
                              { staticClass: "permissions-list" },
                              [
                                _vm._l(moduleGroup.items, function (item) {
                                  return [
                                    item.key === "basic-actions"
                                      ? [
                                          _c("sub-entity-group", {
                                            key: "entity-" + item.key,
                                            attrs: {
                                              subEntity: item,
                                              selectedPermissions:
                                                _vm.role.permissions,
                                              showAsCategory:
                                                moduleGroup.items.length > 1,
                                            },
                                            on: {
                                              toggle:
                                                _vm.togglePermissionWithDependency,
                                              "toggle-all":
                                                _vm.toggleAllSubEntityPermissions,
                                            },
                                          }),
                                        ]
                                      : [
                                          _c("sub-entity-group", {
                                            key: "entity-" + item.key,
                                            attrs: {
                                              subEntity: item,
                                              selectedPermissions:
                                                _vm.role.permissions,
                                              showAsCategory: true,
                                            },
                                            on: {
                                              toggle:
                                                _vm.togglePermissionWithDependency,
                                              "toggle-all":
                                                _vm.toggleAllSubEntityPermissions,
                                            },
                                          }),
                                        ],
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }